import { render, staticRenderFns } from "./FulfillmentOmsIndex.vue?vue&type=template&id=3132fc98&scoped=true&"
import script from "./FulfillmentOmsIndex.vue?vue&type=script&lang=js&"
export * from "./FulfillmentOmsIndex.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentOmsIndex.vue?vue&type=style&index=0&id=3132fc98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132fc98",
  null
  
)

export default component.exports